import { useState } from 'react';
import * as React from 'react';
export default {
  useState,
  React
};